import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  $profilImageSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  constructor() { }
}
